<div class="form-field">
  <span class="form-field__label">{{ label }}</span>
  <app-az-input
    *ngIf="!isTextArea"
    [value]="value"
    [placeholder]="placeholder"
    [disabled]="disabled"
    [type]="type"
    (valueChange)="onValueChange($event)"
  />
  <textarea
    *ngIf="isTextArea"
    class="form-field__textarea"
    [value]="value"
    [placeholder]="placeholder"
    [disabled]="disabled"
    (input)="onValueChange($any($event.target).value)"
  ></textarea>
</div>
